import ListSelectField from "components/ui/atoms/formFields/ListSelectField";
import { useRefinementList } from "react-instantsearch";

const RefinementListField = ({ name, refinementListName, limit, ...props }) => {
  const { items, searchForItems } = useRefinementList({
    attribute:
      refinementListName === undefined
        ? name.replace("__", ".")
        : refinementListName,
    sortBy: ["name:asc"],
    limit: limit,
  });

  const handleOnChange = (event, value) => {
    searchForItems(value);
  };

  return (
    <ListSelectField
      options={items
        .sort((a, b) => a.label.localeCompare(b.label))
        .map((x) => [x.value, x.label])}
      name={name}
      multiple
      onChange={handleOnChange}
      {...props}
    />
  );
};

export default RefinementListField;
